import { gql } from '@apollo/client';

export const VALIDATE_PRODUCT_ID = gql`
  query Flex_ValidatePerchSfProductId(
    $perchSfProductId: String!
    $customerType: String!
    $requireFico: Boolean!
    $stateId: Int!
  ) {
    validation {
      perchSfProductId(
        perchSfProductId: $perchSfProductId
        customerType: $customerType
        requireFico: $requireFico
        stateId: $stateId
      ) {
        isValid
        response
        error {
          message
        }
      }
    }
  }
`;
